import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-documentation',
    templateUrl: './header-documentation.component.html',
    styleUrl: './header-documentation.component.scss',
    standalone: false
})
export class HeaderDocumentationComponent {
  @Input() title: string = '';

  constructor(private router: Router) {}
  backToDocumentationPage(): void {
    this.router.navigate(['documentation']);
  }
}
